const KEYS = {
  TAB: 9,
  SPACE: 32,
  ENTER: 13,
  COMMA: 188,
}

export const delimeterKeys = [KEYS.TAB, KEYS.SPACE, KEYS.ENTER, KEYS.COMMA]
